import { useEffect, useState } from "react";
import { Flame, Target, Users, Zap } from "lucide-react";

interface StatProps {
  icon: React.ElementType;
  value: number;
  label: string;
  suffix?: string;
}

const AnimatedStat = ({ icon: Icon, value, label, suffix = "" }: StatProps) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const increment = value / steps;
    let current = 0;
    
    const timer = setInterval(() => {
      current += increment;
      if (current >= value) {
        setDisplayValue(value);
        clearInterval(timer);
      } else {
        setDisplayValue(Math.floor(current));
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [value]);

  return (
    <div className="flex flex-col items-center gap-2 p-4">
      <Icon className="w-5 h-5 text-primary" />
      <div className="text-2xl md:text-3xl font-display tracking-wide text-foreground">
        {displayValue.toLocaleString()}{suffix}
      </div>
      <div className="text-xs text-muted-foreground uppercase tracking-wider">
        {label}
      </div>
    </div>
  );
};

export const HeroStats = () => {
  return (
    <div className="flex flex-wrap justify-center gap-6 md:gap-12 py-8 px-4 border-y border-border/30 bg-card/30 backdrop-blur-sm">
      <AnimatedStat icon={Users} value={12847} label="Warriors Forged" />
      <AnimatedStat icon={Target} value={89432} label="Goals Achieved" />
      <AnimatedStat icon={Flame} value={2847921} label="GRIT Earned" />
      <AnimatedStat icon={Zap} value={94} label="Success Rate" suffix="%" />
    </div>
  );
};
